import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductAuth18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_659)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 9C0.25 4.16751 4.16751 0.25 9 0.25C13.8325 0.25 17.75 4.16751 17.75 9C17.75 13.8325 13.8325 17.75 9 17.75C4.16751 17.75 0.25 13.8325 0.25 9ZM9 1.75C5.24918 1.75 2.16362 4.59833 1.78832 8.25H10.1894L7.46973 5.53032L8.53039 4.46967L13.0607 9L8.53039 13.5303L7.46973 12.4697L10.1894 9.75H1.78832C2.16362 13.4017 5.24918 16.25 9 16.25C13.0041 16.25 16.25 13.0041 16.25 9C16.25 4.99594 13.0041 1.75 9 1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_659'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

ProductAuth18.displayName = 'ProductAuth18';
export default ProductAuth18;
